import { useQuery } from 'react-query';

import { EVENT_LIST_KEY, EventsResult, getEvents } from '@utils/backend-api/events';

export default function useEvents(page = 1) {
  const { data, isLoading } = useQuery<EventsResult>(EVENT_LIST_KEY, () => getEvents({ page }));
  return { events: data, isFetchingMoreEvents: isLoading };
}
